import employeeNameComponent from './employeeName.component';

let employeeNameModule = angular.module('employeeName', [
])

.component('employeeName', employeeNameComponent)

.name;

export default employeeNameModule;



// WEBPACK FOOTER //
// ./client/app/components/employeeName/employeeName.js